module.exports = __webpack_public_path__ + "img/desert_choco.07be61cc.png";